import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
            <p className="footer-text">
                Made with ❤️ by{' '}
                <a href="https://kinsta.com/" target="_blank" rel="noreferrer">
                    Kinsta
                </a>
                . See how you can use the {' '}
                <a href="https://kinsta.com/docs/kinsta-api-intro/" target="_blank" rel="noreferrer">
                    Kinsta API
                </a>{' '}
                in your projects.
            </p>
        </div>
    )
}

export default Footer